import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Layout2 from "../layouts/Layout2";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Stack } from "react-bootstrap";
import KyatPayWonYu from "../components/KyatPayWonYu";
import Swal from "sweetalert2";
import '../App.css';

const KyatToWonForm = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    
    useEffect(() => {
        if (localStorage.getItem('token') == null || localStorage.getItem('token') == "") {
            Swal.fire({
                text: "Telegram ဖြင့် Login ဝင်ပါ",
                width: 400,
            });
            navigate("/");
        }
    }, []);
    
    return (
        <>
            <Layout2 pageType={"ကျပ်ပေးဝမ်ယူ"}>
                <Helmet>
                    <title>KyatToWon - Form</title>
                </Helmet>
                <div className="exchange-form-container">
                    <div className="exchange-form-header">
                        <Link to={"/kyat-to-won"} className="exchange-form-back">
                            <i className="lni lni-arrow-left"></i>
                            အဆင့် ၁ သို့
                        </Link>
                        <p className="exchange-form-title">အချက်အလက်များဖြည့်သွင်းပါ</p>
                        <span className="exchange-form-step">အဆင့် ၂ မှ ၂</span>
                    </div>
                    
                    <div className="exchange-form-content">
                        <Stack gap={1} className="mt-1 mx-auto">
                            <KyatPayWonYu bank_id={id} />
                        </Stack>
                    </div>
                </div>
            </Layout2>
        </>
    );
}

export default KyatToWonForm;